import React, { useState, useEffect } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';


import { setUser } from "../utils/auth"
import APIS from "../utils/APIS"

const SignUp = () => {
  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState()

  const [step, setStep] = useState(0)

  return (
    <>
      <Helmet>
        <title>Mot de passe oublié | TheScan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: '',
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email("Veuillez renseigner votre email").max(255).required('Veuillez renseigner votre email'),
            })}
            onSubmit={(values, { setSubmitting }) => {
              setAlertMessage("");
              APIS.askForNewPasswordEmail({email : values?.email}).then(result => {
                if (result?.message === "askForNewPasswordEmail") {
                  setStep(1)
                  setSubmitting(false)
                } else {
                  setAlertMessage("Erreur inconnue");
                  setSubmitting(false);
                }
              })
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box sx={{ mb: 2, textAlign:"center" }}>
                  <Typography
                    color="textBlack"
                    variant="h2"
                  >
                    Mot de passe oublié
                  </Typography>
                </Box>

                {step === 1 &&
                  <>
                    <Box sx={{
                      marginTop:"30px",
                      marginBottom:"15px",
                      fontSize:"20px",
                      textAlign:"center",
                      color : "text.pblack",
                    }}>
                      Un email contenant un lien pour modifier votre mot de passe a été envoyé.
                    </Box>
                    <Box sx={{ py: 2 }}>
                      <RouterLink to="/login">
                        <Button
                          color="primary"
                          fullWidth
                          size="large"
                          variant="contained"
                          endIcon={<ChevronRightIcon/>}
                        >
                          Se connecter
                        </Button>
                      </RouterLink>
                    </Box>
                  </>
                }

                {step === 0 &&
                  <>
                    <TextField
                      error={Boolean(touched.email && errors.email)}
                      fullWidth
                      helperText={touched.email && errors.email}
                      label="Adresse Email"
                      margin="normal"
                      name="email"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="email"
                      value={values.email}
                      variant="outlined"
                    />
                    <Box sx={{ py: 2 }}>
                      <Button
                        color="primary"
                        disabled={isSubmitting}
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        endIcon={<ChevronRightIcon/>}
                      >
                        Suivant
                      </Button>
                    </Box>
                    <Box sx={{
                      marginTop:"15px",
                      marginBottom:"15px",
                      fontSize:"16px",
                      textAlign:"center",
                      color : "text.primary",
                    }}>
                      Déjà un compte ?
                      <Link component={RouterLink} to="/login" sx={{marginLeft:"3px"}}>
                        Connectez-vous
                      </Link>
                    </Box>
                    {alertMessage && alertMessage.length > 0 && (
                      <Box
                        sx={{
                          pb: 1,
                          pt: 1,
                        }}
                      >
                        <Typography
                          align="center"
                          color="red"
                          variant="body1"
                        >
                          {alertMessage}
                        </Typography>
                      </Box>
                    )}
                  </>
                }
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </>
  );
};

export default SignUp;
